import { Button, ECGPlot } from 'components';
import React, { FC, useRef } from 'react';
import { ECGWaveFormResponseDto, AccountPublicResponseDto } from 'types/types';
import { GRID_COLOR, STROKE_COLOR } from './constants/constants';
import { useReactToPrint } from 'hooks';

import styles from './styles.module.sass';
import classNames from 'classnames';
import { ButtonType } from 'types/enums';
import { EcgDetails } from './components/components';

type PrintEcgProps = {
  accountData: AccountPublicResponseDto;
  samples: number[];
  ecgWaveForm: ECGWaveFormResponseDto;
};

export const PrintEcg: FC<PrintEcgProps> = ({ ecgWaveForm, accountData }) => {
  const printRef = useRef<null | HTMLDivElement>(null);
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  return (
    <>
      <div ref={printRef} className={classNames([styles.container, styles.print_container])}>
        <EcgDetails accountData={accountData} ecgWaveForm={ecgWaveForm} />

        <div className={styles.plot_container}>
          <ECGPlot
            strokeColor={STROKE_COLOR}
            samples={ecgWaveForm.samples}
            // drawChart={150}
            decreaseWave={40}
            // rate: 256 - good looking, 512 - real
            sampleRate={ecgWaveForm.sampleRate}
            // duration to show 5 real, 9 - fit good
            // durationToShow={15}
            durationToShow={undefined}
            // volts 5 - good-looking, 0.5 - real
            // millivolts={2}
            millivolts={undefined}
            // time 7 good-looking, 10 - real
            startTime={0}
            showGrid={true}
            signalStrokeWidth={1}
            smallGridStrokeWidth={undefined}
            bigGridStrokeWidth={undefined}
            // real : 1
            physicalGridSquareSize={1}
            full={undefined}
            backgroundFill='#fff'
            cellColor={GRID_COLOR}
          />
        </div>
      </div>
      <Button onClick={handlePrint} buttonType={ButtonType.PRIMARY}>
        Download ECG
      </Button>
    </>
  );
};
